/** Same rule as the workspace contact email (DEV-551). */
const CONTACT_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

/** Digits plus the usual separators: "+49 (0)30 123 456", "030/123-456". */
const CONTACT_PHONE_PATTERN = /^\+?[\d\s()./-]+$/;

export function isValidContactEmail(value: string): boolean {
  return CONTACT_EMAIL_PATTERN.test(value.trim());
}

/** 5–15 digits (E.164 allows at most 15). */
export function isValidContactPhone(value: string): boolean {
  const trimmed = value.trim();
  if (!CONTACT_PHONE_PATTERN.test(trimmed)) return false;
  const digits = trimmed.replace(/\D/g, '').length;
  return digits >= 5 && digits <= 15;
}
